export const categories = [
  {
    slug: 'android-app',
    name: '安卓APP',
    description: '适用于安卓手机的免费看片软件下载与安装教程',
    icon: 'ri-android-line',
    articleCount: 28,
  },
  {
    slug: 'ios-app',
    name: '苹果APP',
    description: '适用于iPhone和iPad的免费看片软件推荐与下载指南',
    icon: 'ri-apple-line',
    articleCount: 22,
  },
  {
    slug: 'pc-software',
    name: '电脑软件',
    description: 'Windows和Mac电脑端免费看片软件安装与使用教程',
    icon: 'ri-computer-line',
    articleCount: 18,
  },
  {
    slug: 'tutorial',
    name: '使用教程',
    description: '免费看片软件的使用技巧、设置指南和常见问题解答',
    icon: 'ri-book-open-line',
    articleCount: 35,
  },
  {
    slug: 'latest-recommend',
    name: '最新推荐',
    description: '最新上线的免费看片软件评测与推荐，第一时间了解新选择',
    icon: 'ri-fire-line',
    articleCount: 15,
  },
  {
    slug: 'stable-version',
    name: '稳定版本',
    description: '经过长期验证的稳定版本免费看片软件下载，流畅不卡顿',
    icon: 'ri-shield-check-line',
    articleCount: 12,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || null;
};